import React, { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useHistory } from 'react-router-dom'
import { getQueryStringObject } from 'utils/utils'

import server from 'server/serverController2'

export default function SolMarker() {
  const [cookies, setCookie] = useCookies()
  const history = useHistory()

  const upsertShinhanInfo = async () => {
    return new Promise((resolve, reject) => {
      ;(async () => {
        try {
          let form = {
            is_sol_installed: true,
          }
          let response = await server.putRequestData('users/shinhan', form)
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })()
    })
  }

  useEffect(() => {
    if (cookies?.is_sol_installed === 'true') {
      const queryString = getQueryStringObject()
      const redirectPath = queryString?.redirect_path ? queryString.redirect_path : '/'
      history.replace(redirectPath)
    }
  }, [cookies.is_sol_installed])

  useEffect(() => {
    const queryString = getQueryStringObject()
    const redirectPath = queryString?.redirect_path ? queryString.redirect_path : '/'
    //let intervalEvt = null;
    server.getRequestData('auth', async (res) => {
      try {
        const cookieDomain = process.env.REACT_APP_ENV === 'dev' ? 'localhost' : 'motiners.com'
        if (res.success !== 1) {
          let errData = res.error.res_data
          if (errData['detail_code'] === 'LOGIN_REQ') {
            setCookie('is_sol_installed', 'true', {
              path: '/',
              maxAge: 60 * 60 * 24 * 365,
              domain: cookieDomain,
            })
          } else {
            alert('에러가 발생했습니다. 관리자에게 문의해주세요.')
          }
          return false
        }
        let resData = res.data
        let currUserNo = resData?.userInfo?.user_no
        if (currUserNo) {
          await upsertShinhanInfo()
          history.replace(redirectPath)
        } else {
          setCookie('is_sol_installed', 'true', {
            path: '/',
            maxAge: 60 * 60 * 24 * 365,
            domain: cookieDomain,
          })
        }
      } catch (error) {
        console.log(error)
      }
    })
  }, [])
  return null
}
